import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/internal/Subscription";
import { LayoutUtilsService, RequestService } from "src/app/shared";
import { ChatService } from "src/app/shared/services/chat.service";
import { environment } from "src/environments/environment";
import { EditInvestigatorMapDialogComponent } from "../edit-investigator-map-dialog/edit-investigator-map-dialog.component";
import { LogsInvestigatorMapDialogComponent } from "../logs-investigator-dialog/logs-investigator-dialog.component";
import { CaseService } from "src/app/shared/services/case.service";
import { openCenteredPopup } from "src/app/shared/helpers";

interface Profile {
    _id: string;
    name: string;
    badgeNo: string;
    rank: string;
    phone: string;
    clothing: string;
    division: string;
    pictureLink: string;
    alternative_name: string;
    squad_ref: string;
    remarks: string;
    call_sign: string;
    caseId: string;
    deviceids: any[];
    resources: any[];
    userMetadata: any;
    userMapMetadata: any;
    role: any;
    hideCall: boolean;
    squadMarker: boolean;
    region: string;
    prefecture: string;
}

@Component({
    selector: 'app-view-investigator-dialog',
    templateUrl: './view-investigator-dialog.component.html',
    styleUrls: ['./view-investigator-dialog.component.scss'],
})

export class ViewInvestigatorDialogComponent implements OnInit, OnDestroy {
    public isPopup: boolean = false;
    protected subscriptions: Subscription[] = [];
    public loading: boolean = false;
    public rankEnum: any = [];
    public clothingEnum: any = [];
    // public divisionEnum: any = [];
    public phoneMeta = undefined;
    public clothingMeta = undefined;
    public badgeNoMeta = undefined;
    public squadMeta = undefined;
    public remarkMeta = undefined;
    public callsignMeta = undefined;
    public rankMeta = undefined;
    public divisionMeta = undefined;
    public isInvestigator: boolean = false;
    public currentUser: any = undefined;
    public rolesCannotView: string[] = [environment.customKeys.roleAdmin, environment.customKeys.roleRegionCommanders, environment.customKeys.rolePrefectureCommanders];
    public rolesCannotEdit: string[] = [environment.customKeys.roleAdmin, environment.customKeys.roleRegionCommanders, environment.customKeys.rolePrefectureCommanders];
    public isAdmin: boolean = false;
    public isSuperAdmin: boolean = false;
    public isCommander: boolean = false;
    public isReadOnly: boolean = false;

    constructor(private translate: TranslateService, private requestService: RequestService, public dialogRef: MatDialogRef<ViewInvestigatorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Profile, private router: Router, private chatService: ChatService, private dialog: MatDialog, private caseService: CaseService,
        public layoutUtilsService: LayoutUtilsService) {
        if (window.opener) {
            this.isPopup = true;
        }
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.requestService.currentUserSubject.subscribe((data) => {
                if (data) {
                    this.currentUser = data;
                    this.isReadOnly = data.isReadOnly;
                    this.isAdmin = this.requestService.isUserRoleAdmin();
                    this.isSuperAdmin = this.requestService.isUserRoleSuperAdmin();
                    this.isInvestigator = this.requestService.isUserRoleInvestigator();
                    this.isCommander = this.requestService.isUserRoleCommander();
                }
            })
        );
        this.rankEnum = this.data.userMetadata.fields.find(i => i.name == 'rank').enum;
        this.clothingEnum = this.data.userMetadata.fields.find(i => i.name == 'clothing')?.enum;
        // this.divisionEnum = this.data.userMetadata.fields.find(i => i.name == 'division').enum;
        this.badgeNoMeta = this.data.userMetadata.fields.find(i => i.name == 'badge_no');
        this.rankMeta = this.data.userMetadata.fields.find(i => i.name == 'rank');
        this.divisionMeta = this.data.userMetadata.fields.find(i => i.name == 'division');
        this.phoneMeta = this.data.userMetadata.fields.find(i => i.name == 'phone');
        this.clothingMeta = this.data.userMetadata.fields.find(i => i.name == 'clothing');
        console.log(this.clothingMeta);
        this.callsignMeta = this.data.userMetadata.fields.find(i => i.name == 'call_sign');
        if (this.data.userMapMetadata) {
            this.squadMeta = this.data.userMapMetadata.fields.find(i => i.name == 'squad_ref');
            this.remarkMeta = this.data.userMapMetadata.fields.find(i => i.name == 'remarks');
            // this.callsignMeta = this.data.userMapMetadata.fields.find(i => i.name == 'call_sign');
        }
    }

    ngOnDestroy(): void {

    }

    viewProfile() {
        if (this.data._id) {
            this.dialogRef.close();
            // window.open(`/investigator/${this.data._id}`, "_blank")
            openCenteredPopup(`/investigator/${this.data._id}`, this.translate.instant('Investigator'));
            // this.router.navigate([`/investigator/${this.data._id}`]);
        }
    }
    call() {
        if (this.chatService.ongoingCall) {
            this.layoutUtilsService.alertActionElement('', this.translate.instant('You can only join one meeting at a time'), {
                overlayClickToClose: false,
                showCancelButton: false,
                declineText: this.translate.instant('OK')
            }, 'fit-content');
        } else {
            this.chatService.popupChat.next({
                show: true,
                caseId: this.data.caseId,
                callerId: this.currentUser._id,
                selectedUsers: [{ _id: this.data._id, name: this.data.alternative_name }],
                investigators: [{
                    _id: this.data._id,
                    name: this.data.alternative_name
                }],
                currentCaseInvestigator: { _id: this.data._id, name: this.data.alternative_name },
                invitedBy: this.currentUser._id,
                invitedByName: this.currentUser.alternative_name || this.currentUser.name,
            });
            this.dialogRef.close();
            // const lang = this.translate.currentLang || 'en';
            // // Using '123' as room name consistent with previous manual edits.
            // const url = `${window.location.origin}/call?popup=true`;
            // window.open(url, '_blank', 'height=700,width=1000,status=no,toolbar=no,menubar=no,location=no');
            // this.dialogRef.close();
        }
    }
    chat() {
        // let tokens = [];
        // this.data.deviceids?.map(j => tokens.push(j.deviceId));
        // this.chatService.selectedUser.next({ id: this.data._id, name: this.data.alternative_name, role: undefined });
        // let investigators = [{ _id: this.data._id, name: this.data.alternative_name, deviceids: tokens }];
        // let investigatorGroups = [];
        // if (this.data.caseId) {
        //     investigators = this.caseService.investigators;
        //     investigatorGroups = this.caseService.investigatorGroups;
        // }
        // this.chatService.showChatDialogSubject.next({
        //     show: true,
        //     investigators: investigators,
        //     caseId: this.data?.caseId || undefined,
        //     caseName: undefined,
        //     investigatorGroups: investigatorGroups,
        //     isInvestigatorProfile: this.data?.caseId ? false : true
        // });
        let isGroup = false;
        if (this.data?.caseId) {
            let url = '/global-chat/' + this.data._id + '/' + this.data.caseId;
            // window.open(url);
            if (isGroup) {
                url = '/global-chat/' + this.data._id + '/' + this.data.caseId + '/group';

                openCenteredPopup(url, this.translate.instant('General Chat') + this.data._id + '/' + this.data.caseId + '/group');
            } else {
                openCenteredPopup(url, this.translate.instant('General Chat') + this.data._id + '/' + this.data.caseId);
            }
        } else {
            let url = '/global-chat/' + this.data._id
            openCenteredPopup(url, this.translate.instant('General Chat') + this.data._id);
        }
        this.dialogRef.close();
    }
    editUserMapData() {
        const dialogRef = this.dialog.open(EditInvestigatorMapDialogComponent, {
            autoFocus: false,
            width: this.getResponsiveDialogWidth(),
            data: {
                caseId: this.data.caseId,
                userId: this.data._id,
                metadata: this.data.userMapMetadata,
                title: this.translate.instant('Edit Investigator'),
                region: this.data?.region || undefined,
                prefecture: this.data?.prefecture || undefined
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.action && result.action == 'save') {
                    this.updateMapData(result);
                } else {
                    this.caseService.getInvestigatorsCaseData(this.data.caseId).then(() => {
                        this.caseService.investigatorsMapUpdated.next(true);
                    });
                }
            }
        });
    }
    logs() {
        const dialogRef = this.dialog.open(LogsInvestigatorMapDialogComponent, {
            autoFocus: false,
            width: this.getResponsiveDialogWidth(),
            data: {
                caseId: this.data.caseId,
                userId: this.data._id,
                title: this.translate.instant('Call Log'),
            }
        });
        dialogRef.afterClosed().subscribe(result => {

        });
    }
    updateMapData(result) {
        this.data.squad_ref = result.data.squad_ref;
        this.data.remarks = result.data.remarks;
        // this.data.call_sign = result.data.call_sign;
        this.caseService.getInvestigatorsCaseData(this.data.caseId).then(() => {
            this.caseService.investigatorsMapUpdated.next(true);
        });
    }
    onDeleteSquad() {
        this.caseService.deleteTeammemberByLinkIdMarker(this.data._id, this.data.caseId);
        this.dialogRef.close();
    }

    private getResponsiveDialogWidth(defaultWidth: string = '50vw'): string {
        if (typeof window === 'undefined') {
            return defaultWidth;
        }
        const viewportWidth = window.innerWidth;
        return viewportWidth <= 1024 ? '90vw' : defaultWidth;
    }
}